import {Action} from '@ngrx/store';
import {NotificationData} from './notification.state';

export enum NotificationActionType {
    NOTIFICATION_TOKEN_REQUESTED = '[Notification Effects login$] Notification token requested',
    NOTIFICATION_TOKEN_FETCH_SUCCEEDED = '[Notification Effects notificationTokenRequested$] Notification token fetch succeeded',
    NOTIFICATION_TOKEN_FETCH_FAILED = '[Notification Effects notificationTokenRequested$] Notification token fetch failed',
    NOTIFICATION_TOKEN_PERSIST = '[Notification Effects notificationTokenFetchSucceeded$] Notification token persist',
    NOTIFICATION_TOKEN_PERSIST_SUCCEEDED = '[Notification Effects notificationTokenPersist$] Notification token persist succeeded',
    NOTIFICATION_TOKEN_PERSIST_FAILED = '[Notification Effects notificationTokenPersist$] Notification token persist failed',
    NOTIFICATION_TOKEN_CLEAR = '[Notification Effects logout$] Notification token clear',
    NOTIFICATION_BODY_ARRIVED = '[Notification Service] Notification body arrived',
    NOTIFICATION_BODY_CLEAR = '[Notification Service] Notification body clear',
    NOTIFICATION_TEST = '[Profile Page] Notification test'
}

export class NotificationTokenRequestedAction implements Action {
    readonly type = NotificationActionType.NOTIFICATION_TOKEN_REQUESTED;
    readonly payload;
    constructor(userID: string) {
        this.payload = {userID: userID};
    }
}

export class NotificationTokenFetchSucceededAction implements Action {
    readonly type = NotificationActionType.NOTIFICATION_TOKEN_FETCH_SUCCEEDED;
    readonly payload;
    constructor(token: string, userID: string) {
        this.payload = {token, userID};
    }
}

export class NotificationTokenFetchFailedAction implements Action {
    readonly type = NotificationActionType.NOTIFICATION_TOKEN_FETCH_FAILED;
    readonly payload;
    constructor(reason: any) {
        this.payload = {error: reason};
    }
}

export class NotificationTokenPersistAction implements Action {
    readonly type = NotificationActionType.NOTIFICATION_TOKEN_PERSIST;
    readonly payload;
    constructor(token: string, userID: string) {
        this.payload = {token,userID};
    }
}

export class NotificationTokenPersistSucceededAction implements Action {
    readonly type = NotificationActionType.NOTIFICATION_TOKEN_PERSIST_SUCCEEDED;
    readonly payload;
    constructor(token: string) {
        this.payload = {token};
    }
}

export class NotificationTokenPersistFailedAction implements Action {
    readonly type = NotificationActionType.NOTIFICATION_TOKEN_PERSIST_FAILED;
    readonly payload;
    constructor(reason: any) {
        this.payload = {error: reason};
    }
}

export class ClearNotificationTokenAction implements Action {
    readonly type = NotificationActionType.NOTIFICATION_TOKEN_CLEAR;
}

export class NotificationBodyArrivedAction implements Action {
    readonly type = NotificationActionType.NOTIFICATION_BODY_ARRIVED;
    readonly payload;
    constructor(notificationData: NotificationData) {
        this.payload = {notificationData};
    }
}

export class ClearNotificationBodyAction implements Action {
    readonly type = NotificationActionType.NOTIFICATION_BODY_CLEAR;
}

export class NotificationTestAction implements Action {
    readonly type = NotificationActionType.NOTIFICATION_TEST;
    readonly payload;
    constructor(token: string) {
        this.payload = {token};
    }
}

export type NotificationAction =
    NotificationTokenRequestedAction |
    NotificationTokenFetchSucceededAction |
    NotificationTokenFetchFailedAction |
    ClearNotificationTokenAction |
    NotificationTokenPersistAction |
    NotificationTokenPersistSucceededAction |
    NotificationTokenPersistFailedAction |
    NotificationBodyArrivedAction |
    ClearNotificationBodyAction |
    NotificationTestAction;
